<template>
	<v-sheet elevation="0">
		<FunctionTitle title="" />
		<CommonFlame :title="requirement.requirement_type.name">
			<!-- app-barに表示するボタン群 -->
			<template v-slot:app-bar-btn>
				<v-btn class="ml-2 white--text transparent" @click="openShowRequirement">
					<v-icon class="mr-1">mdi-list-box-outline</v-icon>
					依頼内容確認
				</v-btn>
			</template>
			<template>
				<v-form class="pa-2 d-flex flex-wrap justify-center" ref="form" v-model="valid">
					<div
						class="ma-1 width100p"
						v-for="(column, index) in answerTemplate.answer_columns"
						:key="column.id"
					>
						<v-textarea
							:label="column.name"
							dense
							outlined
							:rules="[]"
							class="mt-4"
							v-model="answerValues[index][`value_${column.data_type}`]"
							v-if="column.data_type == 'text'"
						/>
						<v-text-field
							:label="column.name"
							dense
							outlined
							:rules="[]"
							class="mt-4"
							v-model="answerValues[index][`value_${column.data_type}`]"
							v-if="
								column.data_type == 'feature' ||
								column.data_type == 'url' ||
								column.data_type == 'string'
							"
						/>
						<v-text-field
							:label="column.name"
							type="date"
							dense
							outlined
							:rules="[]"
							class="mt-4"
							v-model="answerValues[index][`value_${column.data_type}`]"
							v-else-if="column.data_type == 'date'"
						/>
						<div class="mt-4" v-else-if="column.data_type == 'boolean'">
							<v-row no-gutters class="mt-1 checkbox-wrapper">
								<v-checkbox
									v-model="answerValues[index][`value_${column.data_type}`]"
									:label="column.name"
									:rules="[]"
									class="mr-2"
									dense
								/>
							</v-row>
						</div>
						<v-text-field
							:label="column.name"
							type="number"
							dense
							outlined
							:rules="integerRules"
							class="mt-4"
							v-model="answerValues[index][`value_${column.data_type}`]"
							v-else-if="column.data_type == 'integer'"
						/>
						<v-text-field
							:label="column.name"
							type="number"
							dense
							outlined
							step="0.01"
							:rules="floatRules"
							class="mt-4"
							v-model="answerValues[index][`value_${column.data_type}`]"
							v-else-if="column.data_type == 'float'"
						/>
						<v-select
							:label="column.name"
							:items="column.answer_column_options"
							item-text="text"
							item-value="text"
							hint="選択してください"
							no-data-text="選択肢ががありません"
							class="mt-4"
							outlined
							dense
							v-if="column.data_type == 'option'"
							v-model="answerValues[index][`value_${column.data_type}`]"
						/>
						<DragUpload
							ref="upload"
							v-else-if="column.data_type == 'file'"
							:label="column.name"
							:targetIndex="index"
							@fileShare="fileShare"
						/>
						<AssociationSelectDialog
							v-else-if="column.data_type == 'target'"
							:label="column.name"
							:value.sync="answerValues[index]"
							:association_value.sync="answerValues[index].name"
							:type="'value_target_type'"
							:id="'value_target_id'"
							:associationName="column.association_name"
						/>
						<SynchronizationForm
							v-else-if="column.data_type == 'synchronization' && column.data_synchronization"
							:reference_id="column.data_synchronization.common_target_id ? id : null"
							:column="column"
							:value.sync="answerValues[index].synchronized_data"
							:display_value.sync="answerValues[index].display_value"
						/>
					</div>
					<v-textarea
						class="mt-4 ma-1 width100p"
						label="伝達事項"
						:rules="[]"
						hint="入力内容以外で依頼した方に伝えるべき内容を記載してください"
						outlined
						dense
						v-model="answer.message"
					/>
				</v-form>
				<v-row no-gutters class="pb-2">
					<v-col cols="4"> </v-col>
					<v-col cols="4">
						<v-row no-gutters justify="center">
							<v-btn color="secondary" @click="openConfirm">
								<v-icon class="mr-2">mdi-checkbox-marked-outline</v-icon>
								確認する
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</template>
		</CommonFlame>
		<RequirementShowDialog ref="show" @reloadIndex="reloadList" :hideAnswer="true" />
		<AnswerConfirm ref="confirm" />
	</v-sheet>
</template>

<script>
import moment from "moment"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import rules from "../../helper/rules"
import FunctionTitle from "../shared/FunctionTitle.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import RequirementShowDialog from "../requirement/components/RequirementInfoDialog.vue"
import DragUpload from "../shared/DragUpload.vue"
import AssociationSelectDialog from "../shared/AssociationSelectDialog.vue"
import SynchronizationForm from "../shared/SynchronizationForm.vue"
import AnswerConfirm from "./components/AnswerConfirm.vue"
export default {
	components: {
		FunctionTitle,
		CommonFlame,
		RequirementShowDialog,
		DragUpload,
		AssociationSelectDialog,
		SynchronizationForm,
		AnswerConfirm,
	},
	data() {
		return {
			id: this.$route.params.id,
			integerRules: [(v) => (v >= -99999 && v <= 99999) || "値の範囲は-99999〜99999です"],
			floatRules: [(v) => (v >= -999 && v <= 999) || "値の範囲は-999=〜999です"],
			rules: rules,
			valid: false,
			moment: moment,
			common: common,
			mainTitle: "回答作成",
			requirement: { id: "", requirement_type: { name: "" } },
			user: {},
			answer: { message: "" },
			answerTemplate: { answer_columns: [] },
			answerValues: [],
			statusIdsHash: {},
		}
	},
	created() {
		this.fetchInfo()
	},
	methods: {
		fetchInfo() {
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/answers/new.json", {
					headers,
					params: { id: this.id },
				})
				.then((res) => {
					this.requirement = res.data.requirement
					this.user = res.data.current_user
					this.answerTemplate = res.data.answer_template
					this.statusIdsHash = res.data.status_ids_hash
					this.answerValues = this.answerTemplate?.answer_columns.map((c) => this.setAnswerValue(c))
				})
				.catch((err) => {
					console.log(err)
					errorHandling.errorResponse(err)
				})
		},
		setAnswerValue(c) {
			let value = { answer_column_id: c.id }
			switch (c.data_type) {
				case "target":
					value = { ...value, value_target_type: "", value_target_id: "", name: "" }
					break
				case "synchronization":
					value = { ...value, synchronized_data: {}, display_value: "" }
					break
				default:
					value[`value_${c.data_type}`] = null
			}
			return value
		},
		reloadList() {
			// ダミー
		},
		fileShare(files, index) {
			this.answerValues[index].value_file = files
		},
		openConfirm() {
			this.$refs.confirm.openDialog(
				this.answer,
				this.answerValues,
				this.requirement,
				this.answerTemplate
			)
			console.log(this.answerValues)
		},
		openShowRequirement() {
			this.$refs.show.openDialog(this.requirement.id, 0)
		},
	},
}
</script>

<style scoped>
.width50p {
	width: 45%;
}
@media (max-width: 600px) {
	.width50p {
		width: 100%;
	}
}
.width100p {
	width: 100%;
}
</style>
